import PropTypes from 'prop-types';
import React from 'react';

function PerilIcon(props) {
    const {value} = props;

    const availablePerilIcons = [
        'Bushfire',
        'Cloudburst',
        'Earthquake',
        'Flood',
        'Freeze',
        'Hail',
        'SevereConvectiveStorm',
        'StormSurge',
        'Terrorism',
        'Hurricane',
        'Typhoon',
        'TropicalCyclone',
        'Tsunami',
        'Windstorm',
        'WorkersCompensation',
        'ELEMENTS',
    ];

    const iconAliases = {
        Hurricane: 'TropicalCyclone',
        Typhoon: 'TropicalCyclone',
    };

    let iconFileName = `Icons-${value}@2x.png`;
    if (availablePerilIcons.indexOf(value) === -1) {
        console.warn('[ WARN ] Peril icon is missing: ' + value);
        iconFileName = 'Icons-missing.svg';
    }
    if (Object.hasOwn(iconAliases, value)) {
        iconFileName = `Icons-${iconAliases[value]}@2x.png`;
    }
    return (
        <div className="peril-icon" title={value}>
            <img src={`img/peril-icons/${iconFileName}`} alt={value} />
        </div>
    );
}

export default PerilIcon;

PerilIcon.propTypes = {
    value: PropTypes.any,
};
